import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "./contentDefaults";

const ContentContext = createContext({ content: null });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then(({ data }) => setContent(data.content || {}))
      .catch(() => setContent({}));
  }, []);
  return <ContentContext.Provider value={{ content }}>{children}</ContentContext.Provider>;
};

export const useContentLoaded = () => useContext(ContentContext).content !== null;

export const useSection = (key) => {
  const { content } = useContext(ContentContext);
  return { ...DEFAULT_CONTENT[key], ...(content?.[key] || {}) };
};
